var link_viewer_wrapper_default = {
  "anchor": "b-G0r",
  "link": "UZSpv"
};
export {
  link_viewer_wrapper_default as default
};
//# sourceMappingURL=link-viewer-wrapper-scss.js.map
